import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { useTicketStore } from '../../../../store/ticketStore';
import { useShallow } from 'zustand/react/shallow';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { dashboardBreadcrumb, ticketSubStatusBreadcrumb, workspaceBreadcrumb } from '../../../../utils/breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import TicketSubStatusTable from './components/ticketSubStatusTable';
import GlobalPopUp from '../../../utility/globalPopUp';
import CreateSubStatusPopup from './components/createSubStatusPopup';

const TicketSubStatus = () => {
    
    const [searchParams, setSearchParams] = useSearchParams()
    const organization_id = searchParams.get('organization_id')

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const { setFlagLoading, handleError, organizationDetails} = useContext(UserContext) as UserContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { getTicketStatusListApi, flagCreateSubStatusPopup, setFlagCreateSubStatusPopup } = useTicketStore(
        useShallow((state) => ({
            getTicketStatusListApi: state.getTicketStatusListApi,
            flagCreateSubStatusPopup: state.flagCreateSubStatusPopup,
            setFlagCreateSubStatusPopup: state.setFlagCreateSubStatusPopup
        }))
    )

    const getTicketStatusListApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getTicketStatusListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getOrganizationName = () => {
        let organization_name = "Organization Name";
        if (organizationDetails) {
            let obj = organizationDetails?.find((organization) => organization.organization_id === Number(organization_id));
            if (obj) {
                organization_name = obj.organization_name;
            }
        }
        return organization_name;
    }

    useEffect(() => {
        getTicketStatusListApiCall(); // Get Ticket Status Call.

        const updatedBreadcrumb = [
            dashboardBreadcrumb,
            ...((!organization_id && organizationDetails && organizationDetails.length > 1) ? [{ ...workspaceBreadcrumb, isActive: true }] : []),
            ...((organization_id || (organizationDetails && organizationDetails.length === 1)) ? [
                { ...workspaceBreadcrumb, path: (organizationDetails && organizationDetails.length > 1) ? "/organization" : `/organization?organization_id=${organization_id}`, isSamePageRedirecting: true, isActive: false },
                { name: getOrganizationName(), path: (organizationDetails && organizationDetails.length > 1) ? "/organization" : `/organization?organization_id=${organization_id}`, isSamePageRedirecting: true, isActive: false },
                { ...ticketSubStatusBreadcrumb, isActive: true }
            ] : [])
        ];

        setBreadCrumbs(updatedBreadcrumb);
    }, []);

    return (
        <>
            <Grid item className={`${globalStyles.fullwidth}`}>
                <Grid container direction={"column"}>
                    <Grid item xs={12} className={styles.organizationMembersGrid}>
                        <Grid container direction={"column"} className={styles.integrationTable}>
                            <Grid item xs={12} className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>
                                Ticket Substatus
                            </Grid>
                            <Grid item xs={12} className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                                <TicketSubStatusTable
                                    getTicketStatusListApiCall={getTicketStatusListApiCall}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>    
            </Grid>

            {flagCreateSubStatusPopup && 
                <GlobalPopUp
                    open={flagCreateSubStatusPopup}
                    onClose={() => { setFlagCreateSubStatusPopup(false) }}
                    handleClose={() => { setFlagCreateSubStatusPopup(false) }}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <CreateSubStatusPopup
                        getTicketStatusListApiCall={getTicketStatusListApiCall}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default TicketSubStatus
